import { ReactComponent as Logo } from "../../shared/logo.svg";
import { ReactComponent as Burger } from "../../shared/burger.svg";
import { ReactComponent as Twitter } from "../../shared/twitter.svg";
import { ReactComponent as Youtube } from "../../shared/youtube.svg";
import { ReactComponent as Telegram } from "../../shared/telegram.svg";
import "./Footer.css";
import { useContext, useState } from "react";
import DimensionsContext from "../../../context/dimensions/dimensions";
import SideBar from "../SideBar/SideBar";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { x } = useContext(DimensionsContext);
  const { i18n } = useTranslation();

  const [openSideBar, setOpenSideBar] = useState(false);

  const changeLanguageHandler = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className="footer">
      {x > 800 ? (
        <>
          <div className="header-side">
            <Link aria-label="Logo" to="/">
              <Logo />
            </Link>
            <Link to="/privacy-policy" className="header-link">
              Privacy Policy
            </Link>
          </div>
          <div className="header-side">
            <select
              className="select"
              name="selectedFilter"
              onChange={(e) => changeLanguageHandler(e.target.value)}
              defaultValue={i18n.language}
            >
              <option className="header-link" value="en">
                English
              </option>
              <option className="header-link" value="ru">
                Русский
              </option>
              <option className="header-link" value="es">
                Español
              </option>
              <option className="header-link" value="pt">
                Português
              </option>
            </select>
            <div className="footer-socials">
              <a aria-label="Twitter" href="https://x.com/FlavySofts">
                <Twitter />
              </a>
              <a
                aria-label="Youtube"
                href="https://www.youtube.com/@FlavySofts"
              >
                <Youtube />
              </a>
              <a aria-label="Telegram" href="https://t.me/FlavySupport">
                <Telegram />
              </a>
            </div>
          </div>
        </>
      ) : (
        <>
          <Link to="/">
            <Logo />
          </Link>
          <div className="footer-socials">
            <a aria-label="Twitter" href="https://x.com/FlavySofts">
              <Twitter />
            </a>
            <a aria-label="Youtube" href="https://www.youtube.com/@FlavySofts">
              <Youtube />
            </a>
            <a aria-label="Telegram" href="https://t.me/FlavySupport">
              <Telegram />
            </a>
          </div>
          <button
            aria-label="Open Sidebar"
            onClick={() => setOpenSideBar(true)}
          >
            <Burger />
          </button>
        </>
      )}

      <SideBar open={openSideBar} onClose={() => setOpenSideBar(false)} />
    </div>
  );
}
